import React, { FC, useState, useRef, useEffect, useContext } from 'react'
import Modal from 'react-modal'
import moment from 'moment'
import prettyMilliseconds from 'pretty-ms'
import ReactPlayer from 'react-player'
import { getUserData } from '../../../Api/backendApi'
import { notify } from 'react-notify-toast'
import axios from 'axios'
import cookie from 'react-cookies'
import ApiURL from '../../../Api/ApiUrl'
import history from '../../../history'
import { getOffset } from '../../../utils/timeOffset'
import AppContext from '../../../context/appContext'
import NavigationBar from '../../NavigationBar/NavigationBar'

import {
  chimeRemoveUserFromQueue,
  chimeReportConferenceBug,
} from '../../../Api/ChimeApi'

import { getSpecificVideoStatus, setVideoStatus } from '../../../Api/videoApi'

import Loader from '../../Loader/Loader'
// import NavigationBar from '../../shared/NavigationBar/NavigationBarContainer'
import { TopColorBar } from '../../SelectSubscriptionPlanScreen/SelectSubscriptionPlanScreen.jsx'
import BackButton from '../../shared/BackButton'
import { modalStyles } from '../../NEW_ProgressScreen/style/ProgressScreenStyle'
import {
  ConferencesScreenContainer,
  MiazgaVideoContainer,
  MiazgaMasterVideo,
  UsersStreamsContainer,
  RemoteTilesContainer,
  VideoTileContainer,
  UserTileContainer,
  UserTileVideoContainer,
  TileVideoElement,
  SettingContainer,
  SettingsButtonsContainer,
  SettingButton,
  ConferenceRoomContainer,
  StartTrainingBadge,
  MutedIndicator,
  CameraOffTile,
  CameraOffIcon,
  UserName,
  ProgressBar,
  ProgressBarValue,
  ProgressBarTime,
  ProgressVolumeContainer,
  VolumeContainer,
  QueueInfoBanner,
  QueueBannerInfoValue,
  QueueBannerInfoText,
  BannerButton,
  ButtonContainer,
  ErrorTextArea,
} from '../styles/ConferencesScreenStyles'
import { CloseButton } from '../../MainScreen/subComponents/DropdownMenu.jsx'
import {
  VolumeUpRounded,
  VolumeOffRounded,
  VolumeDownRounded,
} from '@material-ui/icons'

import mutedIcon from '../../../assets/conferencesScreen/mutedIcon.svg'
import { iAudioVideoDevice } from '../ConferencesSingleRoom'
import GenericBackgroundLayer from '../../../GenericComponents/GenericBackgroundLayer'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericColumn from '../../../GenericComponents/GenericColumn'

interface SingleRoomProps {
  listOfVideoDevices: Array<iAudioVideoDevice>
  listOfAudioOutputDevices: Array<iAudioVideoDevice>
  listOfAudioInputDevices: Array<iAudioVideoDevice>
  setChosenUserAudioInDevice: Function
  setChosenUserAudioOutDevice: Function
  setChosenUserVideoDevice: Function
  chosenUserAudioInDevice: iAudioVideoDevice
  chosenUserAudioOutDevice: iAudioVideoDevice
  chosenUserVideoDevice: iAudioVideoDevice
  muteSelf: Function
  unMuteSelf: Function
  isUserMuted: boolean
  muteAttendeeId: boolean
  setMuteAttendeeId: Function
  masterVideo: any
  forceMute: boolean
  kickAttendeeId: any
  setKickAttendeeId: Function
  gatherKickedOrMutedUserFirebaseIndex: Function
  setKickAttendeeFirebaseIndex: Function
  setMuteAttendeeFirebaseIndex: Function
  kickAttendeeFirebaseIndex: any
  muteAttendeeFirebaseIndex: any
  promiseInProgress: any
  timeToTrainingInMs: any
  showVideoBanner: boolean
  shouldPlayVideo: boolean
  miazgaFolderCurrentVideo: any
  videoStartingTime: string
  startTimeJsDate: any
  startTimeTrainingMs: any
  turnOffCamera: Function
  turnOnCamera: Function
  isCameraOff: boolean
  mutedUsers: any
  // getUserName: Function
  conferences: any
  currentRoom: any
  setShowVideoBanner: Function
  miazgaFolderName: string
  userChoosedVideo: any
}

const SingleRoom: FC<SingleRoomProps> = ({
  listOfVideoDevices,
  listOfAudioOutputDevices,
  listOfAudioInputDevices,
  setChosenUserAudioInDevice,
  setChosenUserAudioOutDevice,
  setChosenUserVideoDevice,
  chosenUserAudioInDevice,
  chosenUserAudioOutDevice,
  chosenUserVideoDevice,
  muteSelf,
  unMuteSelf,
  isUserMuted,
  muteAttendeeId,
  setMuteAttendeeId,
  masterVideo,
  forceMute,
  kickAttendeeId,
  setKickAttendeeId,
  gatherKickedOrMutedUserFirebaseIndex,
  setKickAttendeeFirebaseIndex,
  setMuteAttendeeFirebaseIndex,
  kickAttendeeFirebaseIndex,
  muteAttendeeFirebaseIndex,
  promiseInProgress,
  timeToTrainingInMs,
  showVideoBanner,
  shouldPlayVideo,
  miazgaFolderCurrentVideo,
  videoStartingTime,
  startTimeJsDate,
  startTimeTrainingMs,
  turnOffCamera,
  turnOnCamera,
  isCameraOff,
  mutedUsers,
  // getUserName,
  conferences,
  currentRoom,
  setShowVideoBanner,
  miazgaFolderName,
  userChoosedVideo,
}) => {
  const [isMuteUserModalOpen, toggleMuteUserModalOpen] = useState(false)
  const [isKickModalOpen, toggleKickModalOpen] = useState(false)
  const [tempMuteUserId, setTempMuteUserId] = useState(null)
  const [tempUserKickId, setTempUserKickId] = useState(null)
  const [vidSyncedTimePosition, setVidSyncedTimePosition] = useState(null)
  const [playVideo, setPlayVideo] = useState(false)
  const [userInfo, setUserInfo] = useState(Object)
  const [videoId, setVideoId] = useState(null)
  const [userVideoStatus, setUserVideoStatus] = useState(Object)
  const [userSendedWatchedRequest, setUserSendedWatchedRequest] =
    useState(false)
  const [playedPercentage, setPlayedPercentage] = useState(null)
  const [playedSeconds, setPlayedSeconds] = useState(null)
  const [videoVolume, setVideoVolume] = useState(0.4)
  const [readyToLeaveRoom, setReadyToLeaveRoom] = useState(false)
  const [userSetStatus, setUserSetStatus] = useState(false)
  const [videoShouldPlay, setVideoShouldPlay] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [userReportErrorMessage, setUserReportErrorMessage] = useState('')

  const appContext = useContext(AppContext)
  const muteUserModalRef = useRef(null)
  const videoRef = useRef(null)
  const tileVideoRef = useRef(null)

  useEffect(() => {
    getStatusInfo()
  }, [videoId])

  useEffect(() => {
    if (userChoosedVideo && currentRoom && !userSetStatus) {
      setVideoStatus(
        currentRoom.miazga_id,
        userChoosedVideo.vimeo_video_id,
        userChoosedVideo.video_order
      )
      setUserSetStatus(true)
    }
  }, [userChoosedVideo, currentRoom])

  useEffect(() => {
    getUserInfo()
    // handleUserLeaveRoom()
  }, [])

  useEffect(() => {
    if (timeToTrainingInMs < 0) {
      setShowVideoBanner(false)
    }
  }, [timeToTrainingInMs])

  useEffect(() => {
    setTimeout(() => {
      seekToActualVideoTime()
    }, 2000)
  }, [userChoosedVideo, videoRef, startTimeJsDate, conferences])

  useEffect(() => {
    getVideoId()
    const interval = setInterval(() => {
      seekToActualVideoTime()
    }, 5000)

    return () => clearInterval(interval)
  }, [startTimeTrainingMs, userChoosedVideo])

  useEffect(() => {
    closeStream()
  }, [timeToTrainingInMs])

  const getStatusInfo = async () => {
    let status
    if (videoId) {
      status = await getSpecificVideoStatus(videoId, false)
      setUserVideoStatus(status)
    }
  }

  const setWatchedStatus = () => {}

  const muteUser = async () => {
    const indexKey = await gatherKickedOrMutedUserFirebaseIndex(tempMuteUserId)

    await setMuteAttendeeId({ muteId: tempMuteUserId, muteIndexKey: indexKey })
    toggleMuteUserModalOpen(false)
  }

  const kickUser = async () => {
    const indexKey = await gatherKickedOrMutedUserFirebaseIndex(tempUserKickId)

    await setKickAttendeeId({ kickId: tempUserKickId, kickIndexKey: indexKey })
    toggleKickModalOpen(false)
  }

  const openMuteModal = (e: any) => {
    toggleMuteUserModalOpen(!isMuteUserModalOpen)

    let id = parseInt(e.target.parentElement.previousSibling.id.split('-')[0])
    setTempMuteUserId(id)
  }

  const openKickModal = (e: any) => {
    toggleKickModalOpen(true)

    let id = parseInt(e.target.parentElement.previousSibling.id.split('-')[0])
    setTempUserKickId(id)
  }

  const handleVideoStartPlayingData = () => {
    // DEFINE HERE FUNCTIONS WHICH WILL BE EXECUTED ON PLAYER STARTS PLAYING
  }

  const handleVideoProgressData = (e: any) => {
    // DEFINE HERE FUNCTIONS WHICH WILL BE EXECUTED ON PLAYER PROGRESS

    setPlayedPercentage(e.played)
    setPlayedSeconds(e.playedSeconds)

    if (e.played >= 0.8 && !userSendedWatchedRequest) {
      setUserSendedWatchedRequest(true)

      if (userVideoStatus.length) {
        setVideosWatched()

        notify.show(
          `Gratulujemy! Trening został obejrzany! Kolejny trening odblokuje się w następny dzień treningowy!`,
          'success',
          5000
        )
      }
    }
  }

  const getUserInfo = async () => {
    const userData = await getUserData()
    setUserInfo(userData)
  }

  const toggleOpenErrorModal = () => {
    setOpenErrorModal(true)
  }

  const seekToActualVideoTime = async () => {
    if (
      userChoosedVideo &&
      conferences &&
      videoRef &&
      timeToTrainingInMs &&
      videoRef.current &&
      videoRef.current != null
    ) {
      // Obtain time of current miazga video

      if (
        moment().valueOf() >
          moment(conferences.sessions[0].start_video).valueOf() &&
        moment().valueOf() <
          moment(conferences.sessions[0].start_video).valueOf() +
            userChoosedVideo.duration * 1000
      ) {
        setVideoShouldPlay(true)
        setShowVideoBanner(false)
        let passedSeconds =
          (moment().valueOf() -
            moment(conferences.sessions[0].start_video).valueOf()) /
          1000

        videoRef.current.seekTo(passedSeconds, 'seconds')
      } else if (
        moment().valueOf() <
        moment(conferences.sessions[0].start_video).valueOf()
      ) {
        setShowVideoBanner(true)
      } else {
        setVideoShouldPlay(false)
        setShowVideoBanner(false)
      }

      if (timeToTrainingInMs < 0) {
        setShowVideoBanner(false)
      }

      const videoTime = userChoosedVideo && userChoosedVideo.duration
      // Obtain current time in hour:minutes:seconds format

      const time = new Date()
      // Obtain time when video should start playing
      const videoStart: any = startTimeJsDate

      if (time >= videoStart && time && videoRef.current) {
        const currentTimeInMs = new Date().getTime()

        let videoTimeInSecs = (currentTimeInMs - videoStart) / 1000

        if (videoTime > videoTimeInSecs) {
          await videoRef.current.seekTo(videoTimeInSecs, 'seconds')
          ;(await shouldPlayVideo) === true && (await setPlayVideo(true))
        }
      }
    }
  }

  const getVideoId = () => {
    if (userChoosedVideo) {
      setVideoId(parseInt(userChoosedVideo.uri.split('/')[2]))
    }
  }

  const setVideosWatched = () => {
    const date = new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    const offset = getOffset()
    const setWatchedVideoStatusConfig: any = {
      method: 'patch',
      url: `${ApiURL}/api/videostatus/${userVideoStatus[0].id}/set_as_watched/?offset_ms=${offset}`,
      data: { locked_datetime: date },
      headers: {
        Authorization: `Bearer ${cookie.load('accessToken')}`,
      },
    }

    axios(setWatchedVideoStatusConfig).then((response) => {
      let midnight = new Date()
      midnight.setHours(23, 59, 59, 0)

      cookie.save('miazgaVideoFullyWatched', true, { expires: midnight })
    })
  }

  const changeVolume = (e: any) => {
    setVideoVolume(e.target.value)
  }

  const closeStream = () => {
    const date = new Date()
    const dateInMs = date.getTime()

    if (
      masterVideo &&
      timeToTrainingInMs &&
      conferences &&
      conferences.sessions
    ) {
      if (
        moment(conferences.sessions[0].start_video).valueOf() +
          900000 +
          masterVideo.duration * 1000 <
        dateInMs
      ) {
        notify.show(
          `Dziękujemy za wzięcie udziału w wspólnym treningu. Trening się zakończył.`,
          'success',
          5000
        )

        chimeRemoveUserFromQueue(currentRoom.key, userInfo.id)
        setTimeout(() => {
          history.push('/')
        }, 6000)
      }
    }
  }

  const handleUserLeaveRoom = () => {
    window.addEventListener('beforeunload', function (e) {
      // e.preventDefault()

      chimeRemoveUserFromQueue(currentRoom.key, userInfo.id)
    })
    window.onbeforeunload = () => {
      chimeRemoveUserFromQueue(currentRoom.key, userInfo.id)
    }
  }

  const handleLeaveClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    setReadyToLeaveRoom(true)
  }

  const handleRedirectUser = () => {
    chimeRemoveUserFromQueue(currentRoom.key, userInfo.id)
    setTimeout(() => {
      history.push('/')
    }, 500)
  }

  const handleSendBugReport = () => {
    chimeReportConferenceBug(userReportErrorMessage)
    setOpenErrorModal(false)
  }

  return (
    <>
      <GenericBackgroundLayer
        justify={'flex-start'}
        className={`${
          appContext.appState.theme == 'light' ? 'light' : 'standard'
        } mainpage`}
      >
        <NavigationBar isPlayerView={false} backButtonAction={null} />
        <GenericColumn margin={'auto'} width={'80%'} justify={'flex-start'}>
          <GenericRow justify={'left'}>
            <GenericTextSpan fSize={'3rem'} margin={'3% 0'}>
              {userChoosedVideo && userChoosedVideo.name}
            </GenericTextSpan>
          </GenericRow>

          <GenericRow className="main-content" align={'flex-start'}>
            <GenericColumn width={'50%'} className="main-content__video">
              <MiazgaVideoContainer>
                {showVideoBanner && (
                  <StartTrainingBadge>
                    <GenericTextSpan fSize={'1.5rem'}>
                      Start treningu LIVE nastąpi za:
                    </GenericTextSpan>
                    <GenericTextSpan
                      margin={'2% 0 0 0'}
                      fSize={'2.6rem'}
                      fWeight={'bold'}
                    >
                      {timeToTrainingInMs &&
                        prettyMilliseconds(timeToTrainingInMs, {
                          colonNotation: true,
                        })}
                    </GenericTextSpan>
                    {/* <span>
                      {' '}
                      {timeToTrainingInMs &&
                        prettyMilliseconds(timeToTrainingInMs, {
                          colonNotation: true,
                        })}
                    </span> */}
                  </StartTrainingBadge>
                )}

                <MiazgaMasterVideo
                  onProgress={handleVideoProgressData}
                  onStart={handleVideoStartPlayingData}
                  volume={videoVolume}
                  ref={videoRef}
                  url={
                    userChoosedVideo &&
                    Object.keys(userChoosedVideo).length &&
                    userChoosedVideo.files[0].link
                  }
                  playing={videoShouldPlay}
                  onContextMenu={(e: any) => e.preventDefault()}
                ></MiazgaMasterVideo>

                {/* <button onClick={() => seekToActualVideoTime()}>
            GO TO 30s of video
          </button> */}
              </MiazgaVideoContainer>
            </GenericColumn>

            {/* USERS STREAMS COLUMN */}
            <GenericColumn width={'50%'} className="main-content__user-streams">
              <GenericRow wrap={'wrap'}>
                <VideoTileContainer className="user-stream stream-tile">
                  <UserName className="user-name host">
                    {' '}
                    {userInfo && userInfo.name}
                  </UserName>
                  <MutedIndicator
                    className={` mute-indicator ${isCameraOff && 'dimmed'}`}
                    src={mutedIcon}
                  />

                  {
                    <TileVideoElement
                      controls
                      className={`user-stream ${isCameraOff && 'camera-off'}`}
                      id="videoEl"
                      ref={tileVideoRef}
                    ></TileVideoElement>
                  }
                  {isCameraOff ? (
                    <CameraOffTile className={isCameraOff && 'camera-off-user'}>
                      <CameraOffIcon />
                    </CameraOffTile>
                  ) : null}

                  {!forceMute ? (
                    <>
                      {/* <div>AUDIO USERA 1</div> */}
                      {/* <figure> */}
                      {/* <figcaption>AUDIO</figcaption> */}
                      <audio
                        controls
                        autoPlay
                        id="audioEl"
                        style={{ display: 'none' }}
                      >
                        {/* Your browser does not support the
                    <code>audio</code> element. */}
                      </audio>
                      {/* <button
                    id="mute-button"
                    onClick={() => (isUserMuted ? unMuteSelf() : muteSelf())}
                  >
                    {isUserMuted ? 'Włącz mikrofon' : 'Wycisz się'}
                  </button> */}
                      {/* </figure> */}
                    </>
                  ) : (
                    'Zostales zmutowany'
                  )}
                </VideoTileContainer>

                <VideoTileContainer className="stream-tile">
                  <UserName className="user-name"></UserName>
                  <MutedIndicator className="mute-indicator" src={mutedIcon} />
                  <TileVideoElement controls className="videoChime" />
                  <CameraOffTile className="camera-off-tile">
                    <CameraOffIcon />
                  </CameraOffTile>
                  {/* <div>
              <button onClick={(e) => openMuteModal(e)}>
                Zaglosuj na ucieszenie użytkownika
              </button>
              <button onClick={(e) => openKickModal(e)}>
                Zaglosuj na wyrzucenie użytkownika
              </button>
            </div> */}
                </VideoTileContainer>

                <VideoTileContainer className="stream-tile ">
                  <UserName className="user-name"></UserName>
                  <MutedIndicator className="mute-indicator" src={mutedIcon} />
                  <TileVideoElement controls className="videoChime" />
                  <CameraOffTile className="camera-off-tile">
                    <CameraOffIcon />
                  </CameraOffTile>
                  {/* <div>
              <button onClick={(e) => openMuteModal(e)}>
                Zaglosuj na ucieszenie użytkownika
              </button>
              <button onClick={(e) => openKickModal(e)}>
                Zaglosuj na wyrzucenie użytkownika
              </button>
            </div> */}
                </VideoTileContainer>

                <VideoTileContainer className="stream-tile">
                  <UserName className="user-name"></UserName>
                  <MutedIndicator src={mutedIcon} />
                  <TileVideoElement controls className="videoChime" />
                  <CameraOffTile className="camera-off-tile">
                    <CameraOffIcon />
                  </CameraOffTile>
                  {/* <div>
              <button onClick={(e) => openMuteModal(e)}>
                Zaglosuj na ucieszenie użytkownika
              </button>
              <button onClick={(e) => openKickModal(e)}>
                Zaglosuj na wyrzucenie użytkownika
              </button>
            </div> */}
                </VideoTileContainer>

                <VideoTileContainer className="stream-tile">
                  <UserName className="user-name"></UserName>
                  <MutedIndicator className="mute-indicator" src={mutedIcon} />
                  <TileVideoElement controls className="videoChime" />
                  <CameraOffTile className="camera-off-tile">
                    <CameraOffIcon />
                  </CameraOffTile>

                  {/* <div>
              <button onClick={(e) => openMuteModal(e)}>
                Zaglosuj na ucieszenie użytkownika
              </button>
              <button onClick={(e) => openKickModal(e)}>
                Zaglosuj na wyrzucenie użytkownika
              </button>
            </div> */}
                </VideoTileContainer>

                <VideoTileContainer className="stream-tile">
                  <UserName className="user-name"></UserName>
                  <MutedIndicator className="mute-indicator" src={mutedIcon} />
                  <TileVideoElement controls className="videoChime" />
                  <CameraOffTile className="camera-off-tile">
                    <CameraOffIcon />
                  </CameraOffTile>
                  {/* <div>
              <button onClick={(e) => openMuteModal(e)}>
                Zaglosuj na ucieszenie użytkownika
              </button>
              <button onClick={(e) => openKickModal(e)}>
                Zaglosuj na wyrzucenie użytkownika
              </button>
            </div> */}
                </VideoTileContainer>
              </GenericRow>
            </GenericColumn>
          </GenericRow>

          {/* VIDEO CONTROL BAR ROW */}

          <GenericRow>
            <ProgressVolumeContainer>
              <GenericColumn width={'50%'}>
                <GenericRow>
                  <ProgressBar>
                    <ProgressBarValue
                      width={playedPercentage && playedPercentage * 100}
                    />
                    <ProgressBarTime>
                      {playedSeconds
                        ? `  ${Math.floor(playedSeconds / 60)}  : ${
                            Math.floor(playedSeconds % 60) < 10
                              ? '0' + Math.floor(playedSeconds % 60)
                              : Math.floor(playedSeconds % 60)
                          }  `
                        : '0:00'}
                    </ProgressBarTime>
                  </ProgressBar>
                </GenericRow>

                <GenericRow>
                  <VolumeContainer className="slidecontainer">
                    {videoVolume > 0.6 ? (
                      <VolumeUpRounded />
                    ) : videoVolume > 0 && videoVolume <= 0.6 ? (
                      <VolumeDownRounded />
                    ) : (
                      <VolumeOffRounded />
                    )}
                    <input
                      type="range"
                      id="vol"
                      max="1"
                      min="0"
                      step="0.01"
                      className="slider"
                      onChange={(e) => changeVolume(e)}
                    />
                  </VolumeContainer>
                </GenericRow>
              </GenericColumn>
              <GenericColumn width={'50%'}>
                <GenericRow justify={'space-around'}>
                  <GenericColumn>
                    <SettingButton
                      title={isCameraOff ? 'Włącz kamerę' : 'Wyłącz kamerę'}
                      className={`camera ${isCameraOff && 'camera-off'}`}
                      onClick={
                        isCameraOff
                          ? () => turnOnCamera()
                          : () => turnOffCamera()
                      }
                      // onClick={isCameraOff ? () => turnOnCamera() : () => turnOffCamera()}
                    />
                    <GenericTextSpan margin={'2% 0 0 0'}>
                      {isCameraOff ? 'Włącz kamerę' : 'Wyłącz kamerę'}
                    </GenericTextSpan>
                  </GenericColumn>
                  <GenericColumn>
                    <SettingButton
                      className={`microphone ${
                        isUserMuted && 'microphone-off'
                      }`}
                      title={isUserMuted ? 'Włącz mikrofon' : 'Wyłącz mikrofon'}
                      onClick={() => (isUserMuted ? unMuteSelf() : muteSelf())}
                    />
                    <GenericTextSpan margin={'2% 0 0 0'}>
                      {isUserMuted ? 'Włącz mikrofon' : 'Wyłącz mikrofon'}
                    </GenericTextSpan>
                  </GenericColumn>
                </GenericRow>
              </GenericColumn>
            </ProgressVolumeContainer>
          </GenericRow>
        </GenericColumn>
      </GenericBackgroundLayer>
    </>
  )
}

export default SingleRoom
